import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import './style.scss';
import { IGameURLParams } from '../../../model';
import { useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import { GameBaseInfoComponent } from './game-base-info';
import { RecommendService } from '../services/recommend-service';
import { ServiceAccessStep } from '../services/service-access-step';
import {
  fetchUserPermission,
  PermissionAction,
} from '../../../store/modules/permission';
import { Dispatch } from 'redux';
import { PermissionCheck } from '../../component/permission-check';

export const ConsoleOverview = () => {
  const routeParams = useParams<IGameURLParams>();
  const permissionDispatch = useDispatch<Dispatch<PermissionAction>>();
  const gameList = useSelector((state: IRootState) => state.games.games);
  const envs = useSelector((state: IRootState) => state.games.envs);
  const servicesConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  const myFavoriteList = useSelector(
    (state: IRootState) => state.games.myFavoriteList
  );
  const serviceFavoriteTotal = useSelector(
    (state: IRootState) => state.games.serviceFavoriteTotal
  );
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  useEffect(() => {
    checkPermission();
  }, [routeParams.gameId, routeParams.envId]);

  const getSelectedGameItem = () => {
    return gameList.find((item) => item.gameID === routeParams.gameId);
  };
  const selectedGame = getSelectedGameItem();
  if (!selectedGame || !userInfo) {
    return null;
  }

  const checkPermission = async () => {
    if (!routeParams.gameId) {
      return;
    }
    await fetchUserPermission(permissionDispatch)({
      gameID: routeParams.gameId,
      envID: routeParams.envId ? Number(routeParams.envId) : undefined,
    });
  };

  const renderStepAction = () => {
    return (
      <div className="product-steps">
        <ServiceAccessStep
          selectedGame={selectedGame}
          envs={envs}
          userInfo={userInfo}
        />
      </div>
    );
  };

  return (
    <PermissionCheck
      gameID={routeParams.gameId}
      envID={routeParams.envId}
      contentType="page"
    >
      <div className="overview-box">
        <GameBaseInfoComponent selectedGame={selectedGame} />
        <div className="service-layout">
          {renderStepAction()}
          <div className="product-divider"></div>
          {servicesConfig?.length ? (
            <RecommendService
              servicesConfig={servicesConfig}
              myFavoriteList={myFavoriteList}
              serviceFavoriteTotal={serviceFavoriteTotal}
            />
          ) : null}
        </div>
      </div>
    </PermissionCheck>
  );
};
